export enum CacheSystem {
    Undefined = -1,
    CloudStorage = 0,
    RedisStorage = 1
}